import { Grid, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUpdateUserMutation } from '../../api/authApiSlice';
import FormikButton from '../../components/formik/FormikButton';
import FormikInput from '../../components/formik/FormikInput';
import FormikSelect from '../../components/formik/FormikSelect';
import Screen from '../../components/fragments/Screen';
import Form from '../../components/utilities/Form';
import {
    educationInputs,
    maritalInputs,
    optionInputs,
    salvationInputs,
} from '../../enums';
import { setUser } from '../../store/slices/authSlice';
import errorSnackbar from '../../utils/errorSnackbar';

export default function UpdateProfileScreen() {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const state = useSelector((st) => st);

    const { user } = state.auth;

    const {
        firstName,
        surname,
        estate,
        gender,
        date_of_birth,
        contact: { phoneNumber, email } = {},
        status: {
            maritalStatus,
            baptised,
            confirmed,
            salvation,
            occupation,
            pledge_id,
            education,
        } = {},
        spouse: { username } = {},
    } = user;

    const [updateUserMutation, { isLoading }] = useUpdateUserMutation();

    return (
        <Screen title="Update Profile">
            <Grid item xs={12}>
                <Typography sx={{ mb: 2 }} variant="h6">
                    Basic Profile
                </Typography>
                <Form
                    onSubmit={async (vals) => {
                        const { error, data } = await updateUserMutation({
                            body: {
                                ...vals,
                                phoneNumber,
                                gender,
                                dob: vals.dob?.replaceAll('-', '/'),
                            },
                        });

                        errorSnackbar(error, enqueueSnackbar);

                        if (data) {
                            dispatch(setUser(data?.data));
                            enqueueSnackbar('Profile Updated');
                        }
                    }}
                    initialValues={{
                        firstName,
                        surname,
                        estate,
                        email,
                        dob: date_of_birth,
                        pledge_id,
                    }}
                >
                    <FormikInput
                        name="firstName"
                        label="First Name"
                        placeholder={firstName}
                    />
                    <FormikInput
                        name="surname"
                        label="Last Name"
                        placeholder={surname}
                    />
                    <FormikInput
                        name="email"
                        label="Email Address"
                        placeholder={email}
                    />
                    <FormikInput
                        name="estate"
                        label="Estate"
                        placeholder={estate}
                    />
                    <FormikInput
                        type="date"
                        name="dob"
                        label="DOB"
                        placeholder={date_of_birth}
                    />
                    <FormikInput name="pledge_id" label="Reg/Pledge No" />
                    <div className="d-flex align-items-center justify-content-end">
                        <FormikButton loading={isLoading} variant="contained">
                            Update
                        </FormikButton>
                    </div>
                </Form>
                <Typography sx={{ my: 2 }} variant="h6">
                    Other Info
                </Typography>
                <Form
                    onSubmit={async (vals) => {
                        const { error, data } = await updateUserMutation({
                            body: {
                                ...vals,
                                spouse: { label: username },
                                firstName,
                                surname,
                                estate,
                                gender,
                                email,
                                phoneNumber,
                            },
                            type: 'status',
                        });

                        errorSnackbar(error, enqueueSnackbar);

                        if (data) {
                            dispatch(setUser(data?.data));
                            enqueueSnackbar('Profile Updated');
                        }
                    }}
                    initialValues={{
                        maritalStatus: maritalStatus,
                        baptised: baptised,
                        confirmed: confirmed,
                        salvation,
                        occupation,
                        education,
                    }}
                >
                    <FormikSelect
                        name="maritalStatus"
                        label="Marital Status"
                        data={maritalInputs}
                    />
                    <FormikSelect
                        name="baptised"
                        label="Baptised"
                        data={optionInputs}
                    />
                    <FormikSelect
                        name="confirmed"
                        label="Confirmed"
                        data={optionInputs}
                    />
                    <FormikSelect
                        name="salvation"
                        label="Salvation"
                        data={salvationInputs}
                    />
                    <FormikSelect
                        name="education"
                        label="Education Level"
                        data={educationInputs}
                    />
                    <FormikInput
                        name="occupation"
                        label="Occupation"
                        placeholder={occupation}
                    />
                    <div className="d-flex align-items-center justify-content-end">
                        <FormikButton variant="contained">Update</FormikButton>
                    </div>
                </Form>
            </Grid>
        </Screen>
    );
}
